module.exports = __webpack_public_path__ + "img/20200609_130143.0c4e67ff.jpg";